module.exports = __webpack_public_path__ + "media/total gastrectomy.898b2659.wav";